export default __webpack_public_path__ + "static/media/flyback_async_int_mosfet_dc_psr.f041a057.svg";